// Values indicate the order in which the phases occur.
enum RecruitmentPhase {
  Signup       = 1,
  VideoTest    = 2,
  LanguageTest = 3,
  Done         = 4,
}

export const OrderedRecruitmentPhases: RecruitmentPhase[] = [
  RecruitmentPhase.Signup,
  RecruitmentPhase.VideoTest,
  RecruitmentPhase.LanguageTest,
  RecruitmentPhase.Done,
];

export default RecruitmentPhase;
